import React, { useContext, useEffect, useState } from "react"

import Ding from "assets/ding.mp3"

import EventEmitter from "src/EventEmitter"

import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import CloudroomContext from "../CloudroomContext"

const SessionCanceledModal = () => {
  const { session, localUser } = useContext(CloudroomContext)
  const [sessionCanceled, setSessionCanceled] = useState(
    session.statusState === "canceled"
  )

  useEffect(() => {
    if (localUser.type !== "Student") return

    const onSessionCanceled = () => {
      setSessionCanceled(true)
      new Audio(Ding).play()
    }
    EventEmitter.subscribe("session_canceled", onSessionCanceled)

    return () => EventEmitter.unsubscribe("session_canceled", onSessionCanceled)
  }, [localUser.type])

  if (!sessionCanceled) return null
  return (
    <ModalWithProvidedBody
      isOpen
      hideTrigger
      modalClassName="bootstrap-modal"
      modalTitle="Session Canceled"
      hideCloseButton
    >
      <>
        <div className="modal-body">
          <p className="lead">
            We're sorry, but your tutor will not be able to make your session,
            so unfortunately your session is canceled.
          </p>
        </div>
        <div className="modal-footer">
          <a className="btn solid red" href="/">
            Back to Dashboard
          </a>
        </div>
      </>
    </ModalWithProvidedBody>
  )
}

export default SessionCanceledModal
